export enum Role {
  Admin = 'ADMIN',
  LEAD = 'LEAD',
  User = 'USER',
}

export const Roles: Role[] = Object.values(Role);

export interface prefix {
  country: string;
  prefix: string;
  flag: string;
}

export enum TemplateType {
  email = 'Email',
  sms = 'SMS',
}

export enum statusCampain {
  SCHEDULED = 'SCHEDULED',
  IS_SENDING = 'IS_SENDING',
  SENT = 'SENT',
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  FAILED = 'FAILED',
  STOPPED = 'STOPPED',  // Add this
}

export enum DocumentType {
  pre_enrollment = 'Pre Enrollment',
  post_enrollment = 'Post Enrollment',
}

export enum applicationType {
  lead_application = 'lead_application',
  financial_aid = 'financial_aid'
}